import { Box, Stack, Typography } from "@mui/material";
import React from "react";
import { getS3Url } from "utils/common";

const getImageUrl = (image) => {
  if (!image) return null;
  if (image instanceof File) {
    return URL.createObjectURL(image);
  }
  return getS3Url(image);
};

const InfoImagePreview = ({ config }) => {
  const configStyle = config?.style || {};
  const imageUrl = getImageUrl(config?.image);
  return (
    <Box
      sx={{
        width: configStyle?.width ? Number(configStyle.width) : 180,
        height: configStyle?.height ? Number(configStyle.height) : 120,
        backgroundColor: configStyle?.backgroundColor || "#f5f5f5",
        borderRadius: configStyle?.borderRadius
          ? `${configStyle.borderRadius}px`
          : "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {imageUrl ? (
        <Box
          component="img"
          src={imageUrl}
          alt="Selected"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: configStyle?.objectFit || "cover",
            borderRadius: configStyle?.borderRadius
              ? `${configStyle.borderRadius}px`
              : "12px",
            display: "block",
          }}
        />
      ) : (
        <Stack
          alignItems="center"
          justifyContent="center"
          sx={{ width: "100%", height: "100%" }}
          spacing={1}
        >
          <Typography variant="body2" color="text.secondary" align="center">
            Please select an image
          </Typography>
        </Stack>
      )}
    </Box>
  );
};

export default InfoImagePreview;
